export default __webpack_public_path__ + "static/media/2048.0022beea.png";